module.exports = __webpack_public_path__ + "img/95.2.TN.30bda55f.png";